import apiClient from 'services/axios'
import ApiConfig from 'services/config'
// import errorHandler from 'components/error.handler'

function getGiftCardDesign(businessCode) {
  return apiClient
    .get(`${ApiConfig.GiftCardDesignConfig.GiftCardDesign}${businessCode}`)
    .then(response => response?.data)
}

export default getGiftCardDesign
